<!-- Container Start -->
<div class="content-container">
  <router-outlet></router-outlet>
</div>

<!-- Back to top -->
<a (click)="topFunction()" id="back-to-top" class="btn btn-icon btn-primary back-to-top"><i class="fa fa-arrow-up"></i></a>
